import React from "react";
import { useParams, Link } from "react-router-dom";
import jobsData from "../../data/jobsData";
import descriptions from "../../data/jobDescriptions";
import Footer from "../../components/Home/footer/Footer";
import { FaMapMarkerAlt, FaBriefcase, FaClipboardCheck } from "react-icons/fa";

const JobDetail = () => {
  const { id } = useParams();
  const job = jobsData.find(j => j.title === decodeURIComponent(id));

  if (!job) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h2>Job not found</h2>
        <Link to="/joblistings" className="text-blue-600 underline">
          Back to Jobs
        </Link>
      </div>
    );
  }

  return (
    <>
      <section className="job-View">
        <div className="row align-items-center bg-white p-5">
          <div className="col-md-9">
            <h2 className="text-black">{job.title}</h2>
            <div className="mb-4 flex flex-row">
              <p> Department: {job.department} </p>
            </div>
            <a
              href={job.link || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded px-5 py-3 text-white"
              style={{ backgroundColor: "#0095D9" }}
            >
              Apply Now
            </a>
          </div>
          <div className="col-md-3">
            {/* Placeholder image: reuse an existing image or show a neutral box */}
            <div className="w-100 h-100 bg-gray-100 flex items-center justify-center">
              <span className="text-sm text-gray-500">Company image</span>
            </div>
          </div>
        </div>
      </section>

      <section className="mb-5">
        <div className="jobView container mt-5">
          <div className="row">
            <div className="col-md-9">
              <div>
                <h1 className="mb-4">DESCRIPTION</h1>
                {descriptions[job.title] ? (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: descriptions[job.title].aboutRole }} className="mb-4" />
                    
                    {descriptions[job.title].keyResponsibilities && (
                      <>
                        <h3 className="mt-5 mb-3">Key Responsibilities</h3>
                        <div dangerouslySetInnerHTML={{ __html: descriptions[job.title].keyResponsibilities }} />
                      </>
                    )}
                    
                    {descriptions[job.title].requirements && (
                      <>
                        <h3 className="mt-5 mb-3">Requirements</h3>
                        <div dangerouslySetInnerHTML={{ __html: descriptions[job.title].requirements }} />
                      </>
                    )}
                    
                    {descriptions[job.title].qualifications && (
                      <>
                        <h3 className="mt-5 mb-3">Qualifications</h3>
                        <div dangerouslySetInnerHTML={{ __html: descriptions[job.title].qualifications }} />
                      </>
                    )}
                  </>
                ) : (
                  <p>{job.description || "No detailed description provided."}</p>
                )}
                
                <h3 className="mt-5">Job Details</h3>
                <ul>
                  <li>Department: {job.department}</li>
                  <li>Type: {job.type}</li>
                  <li>Location: {job.location}</li>
                  {job.stipend && <li>Stipend: {job.stipend}</li>}
                  {job.duration && <li>Duration: {job.duration}</li>}
                </ul>
              </div>
            </div>

            <div className="col-md-3">
              <div className="job-details">
                <h3 className="bottom-border">Job details</h3>
                <div className="location d-flex align-items-baseline bottom-border gap-3">
                  <FaMapMarkerAlt style={{ color: "#0095D9" }} /> {job.location}
                </div>
                <div className="internships d-flex align-items-baseline bottom-border gap-3">
                  <FaBriefcase style={{ color: "#0095D9" }} /> {job.type}
                </div>
                <div className="management d-flex align-items-baseline bottom-border gap-3">
                  <FaClipboardCheck style={{ color: "#0095D9" }} /> {job.department}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default JobDetail;
